<script setup lang="ts" name="StepperHeaderCircle">
import BaseCircle from '~/components/BaseCircle.vue';

const { step, isCompleted, disabled } = defineProps<{
  step: number;
  isActive: boolean;
  isCompleted: boolean;
  disabled?: boolean;
}>();
</script>

<template>
  <BaseCircle
    size="md"
    color="primary"
    border="solid"
    transition
    :number="step"
    :background="isCompleted || isActive || disabled ? 'filled' : 'transparent'"
    :disabled="disabled || (!isActive && !disabled && !isCompleted)"
    :icon="isCompleted ? 'ic:baseline-check' : null"
    :data-test="`stepper-header-${step}`"
  />
</template>
